/**
 * The ID of this channel should align with
 * android/app/src/main/res/values/strings.xml
 */
export const PUSH_NOTIFICATIONS_MARKETING_CHANNEL_ID = 'ai.oc.experience.marketing-notifications';
export const PUSH_NOTIFICATION_ACTION_TAP = 'tap';
